import { render } from "./EinkaufslisteAnzeigenView.vue?vue&type=template&id=913c9e4a&scoped=true"
import script from "./EinkaufslisteAnzeigenView.vue?vue&type=script&lang=js"
export * from "./EinkaufslisteAnzeigenView.vue?vue&type=script&lang=js"

import "./EinkaufslisteAnzeigenView.vue?vue&type=style&index=0&id=913c9e4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-913c9e4a"]])

export default __exports__